import React from 'react';
import {
  weekDays,
  parseStartTimeEndTime,
  getTimings,
} from '../../dashboard/actions';
import { FormattedMessage } from 'react-intl';
import defaultMsg from '../../../translations/lang/en-US.json';
import moment from 'moment';
import { flatten } from 'lodash';

export class RestaurantAvailableTimings extends React.Component {
  handleChange(e) {
    this.props.timeSelected(e.target.value);
  }

  getOptions(minimumNoticeTime, selectedDate, startTime, endTime) {
    const options = getTimings(
      minimumNoticeTime,
      selectedDate,
      startTime,
      endTime
    );
    return options.map((item, i) => {
      return (
        <option key={item.formattedTime} value={item.formattedTime}>
          {item.formattedTime}
        </option>
      );
    });
  }

  render() {
    const selectedDate =
      this.props.compareDay === false && this.props.dateChanged == false
        ? moment().add(1, 'days')
        : Number(this.props.selectedDate);
    const weekDayNumber = new Date(selectedDate).getDay();
    const weekDay = weekDays[weekDayNumber];
    const timings = parseStartTimeEndTime(
      this.props.weekDayConfiguration,
      selectedDate
    );
    const timeOptions = timings
      ? flatten(
          timings.map(config =>
            this.getOptions(
              this.props.minimumNoticeTime,
              selectedDate,
              config.starttime,
              config.endtime
            )
          )
        )
      : false;
    return (
      <div>
        {timings && timeOptions.length > 0 ? (
          <select
            className="timePicker"
            name="time"
            onChange={this.handleChange.bind(this)}
            value={!this.props.selectedTime ? '' : this.props.selectedTime}
          >
            <option value="">
              <FormattedMessage
                id="selectTime"
                defaultMessage={defaultMsg.selectTime}
              />
            </option>
            {timeOptions}
          </select>
        ) : (
          <div className="text-danger font-medium" style={{ paddingTop: 12 }}>
            {timings &&
            timeOptions.length === 0 &&
            new Date().getDay() === weekDayNumber ? (
              <FormattedMessage
                id="closedForToday"
                defaultMessage={defaultMsg.closedForToday}
              />
            ) : (
              <FormattedMessage id="closedOnDay" values={{ weekDay }} />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default RestaurantAvailableTimings;



// WEBPACK FOOTER //
// ./src/views/checkout/components/RestaurantAvailableTimings.jsx